/**
 * Blob URL 관리 유틸리티
 * 이미지 Blob 객체로부터 URL을 생성하고 관리하는 함수들
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * Blob URL 생성 함수
 * 
 * @param blob Blob 또는 File 객체
 * @param log 로깅 함수 (옵션)
 * @returns 생성된 Blob URL
 */ export var createBlobUrl = function(blob, log) {
    try {
        var url = URL.createObjectURL(blob);
        if (log) {
            log('Blob URL 생성:', url);
        }
        return url;
    } catch (error) {
        console.error('Blob URL 생성 오류:', error);
        return '';
    }
};
/**
 * Blob URL 해제 함수
 * 더 이상 필요하지 않은 URL을 메모리에서 해제
 * 
 * @param options.url 해제할 Blob URL
 * @param options.log 로깅 함수 (옵션)
 * @returns 성공 여부
 */ export var revokeBlobUrl = function(options) {
    var url = options.url, log = options.log;
    if (!url || !url.startsWith('blob:')) {
        return false;
    }
    try {
        URL.revokeObjectURL(url);
        if (log) {
            log('Blob URL 해제:', url);
        }
        return true;
    } catch (error) {
        console.warn('Blob URL 해제 실패:', error);
        return false;
    }
};
/**
 * Blob URL 유효성 검사 함수
 * 주어진 Blob URL이 여전히 유효한지 확인
 * 
 * @param url 검사할 Blob URL
 * @returns Promise<boolean> URL이 유효한지 여부
 */ export var isBlobUrlValid = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(url) {
        var response, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!url || !url.startsWith('blob:')) {
                        return [
                            2,
                            false
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(url, {
                            method: 'HEAD'
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response.ok
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function isBlobUrlValid(url) {
        return _ref.apply(this, arguments);
    };
}();
